/**
 * Init popular contents
 */
export default function(sdk, sdkConfig){
  // Set up the top 3
  if (document.querySelector('#popular')) {
    // Set up popular module before the contact form
    var popular = sdk.component('popular', '#popular', {
      length: 3,
      contents: {
        openContentOnClick: false,
      },
      labels: {
        POPULAR_TITLE: 'Questions les plus fréquentes',
      },
    });
    popular.$on('click',(content) => {
      window.open(`${sdkConfig.helpsiteURL.replace(/\/$/, '')}/content/${content.slug}/?o=gp`,'_blank');
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/helpers/popular-init.js